import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const DetailsPageLink = ({ to, label, extraState = {}, ...props }) => {
  const location = useLocation();

  const previousState = location.state || {};

  const preservedState = {
    filters: previousState.filters || {},
    searchValue: previousState.searchValue || '',
    page: previousState.page || 1,
    ...extraState,
  };

  return (
    <Link to={to} state={preservedState} {...props}>
      <span style={{ whiteSpace: 'nowrap' }}> {label}</span>
    </Link>
  );
};

export default DetailsPageLink;
